// extracted by mini-css-extract-plugin
export default {"carousel":"carousel_carousel__nz5se"};